import React, { useState, useEffect } from 'react';

function LiveClock({ timezone = 'Australia/Sydney', className = '' }) {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Update time every second
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(timer);
  }, []);

  // Format the time with timezone
  const formatDateTime = (date) => {
    try {
      return date.toLocaleString('en-AU', {
        timeZone: timezone,
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
        timeZoneName: 'short'
      });
    } catch (error) {
      console.error('Error formatting date:', error);
      return date.toLocaleString();
    }
  };

  return (
    <div className={`text-sm font-medium ${className}`}>
      <div className="flex items-center gap-2">
        <span className="text-gray-600">🕐</span>
        <span className="text-gray-700">{formatDateTime(currentTime)}</span>
      </div>
    </div>
  );
}

export default LiveClock;
